<div [formGroup]="formGroup"
     class="range-slider">
    <div class="label min">{{ minLabel }}</div>
    <div class="label max">{{ maxLabel }}</div>
    <input #minInput
           [max]="max"
           [min]="min"
           class="slider from"
           formControlName="minValue"
           type="range">
    <input #maxInput
           [max]="max"
           [min]="min"
           class="slider to"
           formControlName="maxValue"
           type="range">
</div>
